/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .trip-booking-package-total-row[_ngcontent-%COMP%]{padding:12px 8px}[_nghost-%COMP%]   .ar-title[_ngcontent-%COMP%]{color:#d3d3d3;text-transform:uppercase}"];
export { styles as styles };
